import React from 'react';
import { spinWheelActionTypes } from '@/constants/types';
import Icon from '../Icon';
import Text from '../Text';
import SpinningWheelImage from './SpinningWheelImage';

function SpinTheWheelBar({ onSpin }) {
  return (
    <div className="container mx-auto">
      <div className="sm:w-1/2 bg-spin-the-wheel flex items-center gap-x-2 px-16 py-6 rounded-xl my-16 shadow-trending-categories-search">
        <div className="flex gap-x-2 items-center">
          <SpinningWheelImage />

          <Text type="paragraph" className="text-sm text-white font-semibold">
            Spin the Wheel
          </Text>
        </div>

        <Icon
          type="angle-down"
          className="-rotate-90 ml-auto hover:cursor-pointer"
          color="#FFFFFF"
          onClick={() => {
            onSpin(spinWheelActionTypes.openModal);
          }}
        />
      </div>
    </div>
  );
}

export default SpinTheWheelBar;
